"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceDocumentation = void 0;
exports.SourceDocumentation = {
    builtins: {}
};
//# sourceMappingURL=index.js.map